export default function deepcopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}



// WEBPACK FOOTER //
// ./src/utils/deepcopy.js